import {UserDocument} from '../UserDocument';
import {useOptionalCurrentUser} from './useOptionalCurrentUser';

export function useCurrentUser(): UserDocument {
  const maybeCurrentUser = useOptionalCurrentUser();
  /* v8 ignore next -- @preserve */
  if (!maybeCurrentUser) {
    throw new Error('User must be defined prior to calling useCurrentUser');
  }
  return maybeCurrentUser;
}
